<dc-global-header *ngIf="showHeadFooter" [user]="user"></dc-global-header>
<router-outlet (activate)="changeOfRoutes($event)"></router-outlet>
<dc-global-footer  *ngIf="showHeadFooter"></dc-global-footer>
